import {
  Button,
  Form,
  Layout,
  Space,
  Spin,
  Steps,
  Typography,
  message
} from "antd";
import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import APIService from "../Api/api.service";
import Authorization from "../components/patientrequest/authorization";
import Document from "../components/patientrequest/documents";
import Facility from "../components/patientrequest/facility";
import PatientInformation from "../components/patientrequest/patientinformation";
import Recipient from "../components/patientrequest/recipient";
import Records from "../components/patientrequest/records";
import Requester from "../components/patientrequest/requester";
import { ThemeContext } from "../context/themeContext";
import { dataDate } from "../components/dateValidator";
import CustomHeader from '../components/common/Header';
import { useTranslation } from "react-i18next";
import { ROUTES } from "../constants/Route";
import {LOGO_SVG_URL } from "../constants/common";


const FormItemLayout = {
  labelCol: {
    xl: {
      span: 24,
    },
  },
  wrapperCol: {
    xl: {
      span: 24,
    },
  },
};

const PatientDetails = (props) => {
  const { theme } = useContext(ThemeContext)
  const { t, i18n } = useTranslation();
  const navigate = useNavigate(); // Hook for navigation
  const [current, setCurrent] = useState(0);
  const [loading, setLoading] = useState(false);
  const [apiservice] = useState(() => new APIService());
  const { Content, Footer, Header } = Layout;
  const [form] = Form.useForm();
  const [defaultFile, setDefaultFile] = useState({})

  const [patientDetailsData, setpatientDetails] = useState({
    IsPatient: "",
    AssociatedWithPatient: "",
    IsPatientMinor: "",
    PFirstName: "",
    PLastName: "",
    PatientPhoneNumber: "",
    PDOB: "",
    PEmail: "",
    PAddLine1: "",
    PAddLine2: "",
    PCity: "",
    PState: "",
    PZipCode: "",
    RequesterFName: "",
    RequesterLName: "",
    RequesterPhoneNumber: "",
    RequesterEmail: "",
    RequesterAddLine1: "",
    RequesterAddLine2: "",
    RequesterCity: "",
    RequesterState: "",
    RequesterZipCode: "",
    FacilityType: "",
    FacilityName: "",
    Facility_Email: "",
    FacilityPhoneNumber: "",
    FacilityAddressLine1: "",
    FacilityAddressLine2: "",
    FacilityCity: "",
    FacilityState: "",
    FacilityZipCode: "",
    RecordInformationTimeFrame: "",
    RecordInformationStartDate: "",
    RecordInformationEndDate: "",
    RecordInformationRecordType: "",
    RecipientDiscloseRecordsTo: "",
    RecipientMethodOfRelease: "",
    RecipientName: "",
    RecipientEmail: "",
    RecipientVerifyEmail: "",
    RecipientFax: "",
    RecipientPhoneNumber: "",
    Authorization_Signature: "",
    Authorization_Auth1: "",
    Authorization_Auth2: "",
    Authorization_Auth3: "",
    Authorization_Auth4: "",
    DocumentHIPPAAuthorization: [],
    DocumentAdditionalDoc: [],
    DocumentAdditionalNotes: "",
    recordsDisclose: '',
    RecipientAddress1: "",
    RecipientAddress2: "",
    RecipientCity: "",
    RecipientState: "",
    RecipientZipCode: "",
  });
  const [checkedKeys, setCheckedKeys] = useState([]);
  const onsubmit = async () => {
    form
      .validateFields()
      .then(async () => {
        setLoading(true);
        if (patientDetailsData.IsPatient.toString().toLowerCase() == "yes") {
          patientDetailsData.RequesterFName = patientDetailsData.PFirstName.toString();
          patientDetailsData.RequesterLName = patientDetailsData.PLastName.toString();
          patientDetailsData.RequesterPhoneNumber = patientDetailsData.PatientPhoneNumber.toString();
          patientDetailsData.RequesterEmail = patientDetailsData.PEmail.toString();
          patientDetailsData.RequesterAddLine1 = patientDetailsData.PAddLine1.toString();
          patientDetailsData.RequesterAddLine2 = patientDetailsData.PAddLine2.toString();
          patientDetailsData.RequesterCity = patientDetailsData.PCity.toString();
          patientDetailsData.RequesterState = patientDetailsData.PState.toString();
          patientDetailsData.RequesterZipCode = patientDetailsData.PZipCode.toString();
        }
        const patientDetailsModel = {
          "IsPatient": patientDetailsData.IsPatient.toString().toUpperCase(),//IsPatient.toString(),
          "Is_Patient_Minor": patientDetailsData.IsPatientMinor.toString().toUpperCase(),//IsPatientMinor.toString(),
          "AssociatedWithPatient": patientDetailsData.AssociatedWithPatient != "" ? patientDetailsData.AssociatedWithPatient.toString() == "1" ? "Parent/Legal Guardian" : patientDetailsData.AssociatedWithPatient.toString() == "2" ? "Authorized Representative" : "NA" : "NA",
          "PatientFirstName": patientDetailsData.PFirstName.toString(),
          "PatientLastName": patientDetailsData.PLastName.toString(),
          // "PatientDateOfBirth": patientDetailsData.PDOB != "" ? patientDetailsData.PDOB : null,//"2000-08-13T14:27:35.985Z", //new Date(PDOB).toString(),
          "PatientDateOfBirth": patientDetailsData.PDOB != "" ? dataDate(patientDetailsData.PDOB) : null,//"2000-08-13T14:27:35.985Z", //new Date(PDOB).toString(),
          "PatientEmail": patientDetailsData.PEmail.toString(),
          "PatientAddressLine1": patientDetailsData.PAddLine1.toString(),
          "PatientAddressLine2": patientDetailsData.PAddLine2.toString(),
          "PatientPhoneNumber": patientDetailsData.PatientPhoneNumber.toString(),
          "PatientCity": patientDetailsData.PCity.toString(),
          "PatientState": patientDetailsData.PState.toString(),
          "PatientZipCode": patientDetailsData.PZipCode.toString(),
          "RequesterFName": patientDetailsData.RequesterFName.toString(),
          "RequesterLName": patientDetailsData.RequesterLName.toString(),
          "RequesterPhoneNumber": patientDetailsData.RequesterPhoneNumber.toString(),
          "RequesterEmail": patientDetailsData.RequesterEmail.toString(),
          "RequesterAddressLine1": patientDetailsData.RequesterAddLine1.toString(),
          "RequesterAddressLine2": patientDetailsData.RequesterAddLine2.toString(),
          "RequesterCity": patientDetailsData.RequesterCity.toString(),
          "RequesterState": patientDetailsData.RequesterState.toString(),
          "RequesterZipCode": patientDetailsData.RequesterZipCode.toString(),
          "FacilityType": patientDetailsData.FacilityType.toString(),
          "FacilityName": form.getFieldValue("ffacilityname").toString(),
          "Facility_Email": patientDetailsData.Facility_Email.toString(),//form.getFieldValue("Facility_Email") != "undefined" ? form.getFieldValue("Facility_Email").toString() : "",
          "FacilityPhoneNumber": patientDetailsData.FacilityPhoneNumber.toString(),//form.getFieldValue("fphone") != "undefined" ? form.getFieldValue("fphone").toString() : "",
          "FacilityAddressLine1": patientDetailsData.FacilityAddressLine1.toString(),//form.getFieldValue("faddress1").toString(),
          "FacilityAddressLine2": patientDetailsData.FacilityAddressLine2.toString(),//form.getFieldValue("faddress2") != "undefined" ? form.getFieldValue("faddress2").toString() : "",
          "FacilityCity": form.getFieldValue("fcity").toString(),
          "FacilityState": form.getFieldValue("fstate").toString(),
          "FacilityZipCode": form.getFieldValue("fzipcode").toString(),
          "Facility_StartDate": null,
          "Facility_EndDate": null,
          "RecordInformationTimeFrame": patientDetailsData.RecordInformationTimeFrame.toString(),
          "RecordInformationStartDate": patientDetailsData.RecordInformationStartDate != "" ? dataDate(patientDetailsData.RecordInformationStartDate) : null,
          "RecordInformationEndDate": patientDetailsData.RecordInformationEndDate != "" ? dataDate(patientDetailsData.RecordInformationEndDate) : null,
          "RecordInformationRecordType": patientDetailsData.RecordInformationRecordType.toString(),
          "DiscloseRecordsTo": patientDetailsData.RecipientDiscloseRecordsTo.toString(),
          "MethodOfRelease": patientDetailsData.RecipientMethodOfRelease.toString(),
          "RecipientName": form.getFieldValue("nameorganization").toString(),//patientDetailsData.RecipientName.toString(),
          "RecipientEmail": form.getFieldValue("remail").toString(),//patientDetailsData.RecipientEmail.toString(),
          "RecipientVerifyEmail": patientDetailsData.RecipientVerifyEmail.toString(),
          "RecipientFax": patientDetailsData.RecipientFax.toString(),//form.getFieldValue("faxnumber").toString(),//
          "RecipientPhoneNumber": patientDetailsData.RecipientPhoneNumber.toString() != "" ? patientDetailsData.RecipientPhoneNumber.toString() : form.getFieldValue("phone").toString(),//patientDetailsData.RecipientPhoneNumber.toString(),
          "RecipientAddressLine1":(form.getFieldValue("RecipientAddress1") ?? patientDetailsData.RecipientAddress1 ?? "").toString(),
          "RecipientAddressLine2":(form.getFieldValue("RecipientAddress2") ?? patientDetailsData.RecipientAddress2 ?? "").toString(),
          "RecipientCity":(form.getFieldValue("RecipientCity") ?? patientDetailsData.RecipientCity ?? "").toString(),
          "RecipientState":(form.getFieldValue("RecipientState") ?? patientDetailsData.RecipientState ?? "").toString(),
          "RecipientZipCode":(form.getFieldValue("RecipientZipCode") ?? patientDetailsData.RecipientZipCode ?? "").toString(),
          "Authorization_Signature": patientDetailsData.Authorization_Signature.toString(),
          "Authorization_Auth1": patientDetailsData.Authorization_Auth1,
          "Authorization_Auth2": patientDetailsData.Authorization_Auth2,
          "Authorization_Auth3": patientDetailsData.Authorization_Auth3,
          "Authorization_Auth4": patientDetailsData.Authorization_Auth4,
          "DocumentHIPPAAuthorization": patientDetailsData.DocumentHIPPAAuthorization,
          "DocumentFMLAForm": [],
          "DocumentAdditionalDoc": patientDetailsData.DocumentAdditionalDoc,
          "DocumentAdditionalNotes": patientDetailsData.DocumentAdditionalNotes.toString(),
          "Token": sessionStorage.getItem("secrateKey"),
          "Is_FMLA_Req": false,
          "ClientName": sessionStorage.getItem("currentActiveClient"),
          "RequestLanguage": i18n.language
        }
        if (sessionStorage.getItem("secrateKey") != null) {
          let result = await apiservice.postRequest(
            "SavePatientDetails/PatientInformation",
            patientDetailsModel
          );

          if (result.status !== null) {
            if (result == "SUCCESS") {
              setLoading(false);
              navigate(ROUTES.THANKS);
            }
            else if (result == "Failed") {
              setLoading(false);
              message.error(t("common:something_went_wrong_please_try_again"));
            }
          }
        }
        else {
          setLoading(false);
          message.error(t("common:something_went_wrong_please_try_again"));
        }
      })
      .catch((info) => {
        setLoading(false);
      });
  };
  const steps = [
    {
      title: t("patientDetails:patient"),
    },
    {
      title: t("patientDetails:requester"),
    },
    {
      title: t("patientDetails:facility"),
    },
    {
      title: t("patientDetails:records"),
    },
    {
      title: t("patientDetails:recipient"),
    },
    {
      title: t("patientDetails:authorization")
    },
    {
      title: t("patientDetails:documents"),
    },
  ];

  const getChildData = (value, name) => {
    let res = { ...patientDetailsData, [name]: value }
    setpatientDetails(res);
  }
  const next = () => {
    form
      .validateFields()
      .then(() => {
        setCurrent(patientDetailsData.IsPatient === "yes" && current === 0 ? current + 2 : current + 1);
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  const prev = () => {
    setCurrent(patientDetailsData.IsPatient === "yes" && current === 2 ? current - 2 : current - 1);
  };
  const onFinish = (values) => {
    navigate(ROUTES.THANKS);
  };
  const items = steps.map((item) => ({
    key: item.title,
    title: item.title,
  }));

  return (
    <Layout className="bg-white">
      <Spin spinning={loading}>
       <CustomHeader />
        <Content className="p-6 pb-0">
          <div className="container mx-auto">
            <Steps
              className={theme}
              type="default"
              labelPlacement={"vertical"}
              current={current}
              items={items}
            />
            {current === 0 && (
              <Form
                key={`step1-${i18n.language}`}
                {...FormItemLayout}
                form={form}
                variant="outlined"
                onFinish={onFinish}
                initialValues={{ remember: true }}
                colon={false}
                name="step1"
                layout="vertical"
              >
                <PatientInformation getChildData={getChildData} form={form} patientDetailsData={patientDetailsData} />
              </Form>
            )}
            {current === 1 && patientDetailsData.IsPatient === "no" &&
              <Form
                key={`step2-${i18n.language}`}
                {...FormItemLayout}
                form={form}
                variant="outlined"
                onFinish={onFinish}
                initialValues={{ remember: true }}
                colon={false}
                name="step2"
                layout="vertical"
              >
                <Requester getChildData={getChildData} form={form} />
              </Form>
            }
            {current === 2 &&
              <Form
                key={`step3-${i18n.language}`}
                {...FormItemLayout}
                form={form}
                variant="outlined"
                onFinish={onFinish}
                initialValues={{ remember: true }}
                colon={false}
                name="step2"
                layout="vertical"
              >
                <Facility getChildData={getChildData} form={form} />
              </Form>
            }
            {current === 3 &&
              <Form
                key={`step4-${i18n.language}`}
                {...FormItemLayout}
                form={form}
                variant="outlined"
                onFinish={onFinish}
                initialValues={{ remember: true }}
                colon={false}
                name="step4"
                layout="vertical"
              >
                <Records
                  getChildData={getChildData} form={form} patientDetailsData={patientDetailsData}
                  checkedKeys={checkedKeys}
                  setCheckedKeys={setCheckedKeys} />
              </Form>
            }
            {current === 4 &&
              <Form
                key={`step5-${i18n.language}`}
                {...FormItemLayout}
                form={form}
                variant="outlined"
                onFinish={onFinish}
                initialValues={{ remember: true }}
                colon={false}
                name="step5"
                layout="vertical"
              >
                <Recipient getChildData={getChildData} form={form} patientDetailsData={patientDetailsData} />
              </Form>
            }
            {current === 5 &&
              <Form
                key={`step6-${i18n.language}`}
                form={form}
                variant="outlined"
                onFinish={onFinish}
                initialValues={{ remember: true }}
                colon={false}
                name="step6"
                layout="vertical"
              >
                <Authorization getChildData={getChildData} form={form} patientDetailsData={patientDetailsData} />
              </Form>
            }

            {current === 6 &&
              <Form
                key={`step7-${i18n.language}`}
                form={form}
                variant="outlined"
                onFinish={onFinish}
                initialValues={{ remember: true }}
                colon={false}
                name="step6"
                layout="vertical"
              >
                <Document getChildData={getChildData} form={form} patientDetailsData={patientDetailsData} defaultFile={defaultFile} setDefaultFile={setDefaultFile} />
              </Form>
            }

            <Space className="mt-8 w-full justify-between">
              {current > 0 && (
                <Button
                  type="primary"
                  onClick={() => prev()}
                >
                  {t("common:back")}
                </Button>
              )}
              {current === steps.length - 1 && (
                <Button
                  type="primary"
                  onClick={current === 6 ? onsubmit : next}
                >
                  {current === 6 ? t("common:submit") : t("common:next")}
                </Button>
              )}
              {!current && (
                <Link to={ROUTES.PATIENT}>
                  <Button
                    type="primary"
                  >
                    {t("common:back")}
                  </Button>
                </Link>
              )}
              {current < steps.length - 1 && (
                <Button
                  type="primary"
                  onClick={() => next()}
                >
                  {t("common:next")}
                </Button>
              )}
            </Space>
            <Footer className="welcome-footer bg-white">
              <img
                className="m-auto"
                alt="Provider1st Logo"
                src={window.location.origin + LOGO_SVG_URL}
              />
            </Footer>
          </div>
        </Content>
      </Spin>
    </Layout>
  );
};

export default PatientDetails;
